/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const self = (state: RootState) => state.preorder;

export const getForm = createSelector(self, (state) => state.form);
export const getPreorder = createSelector(self, (state) => state.preorder);
export const getPreorderData = createSelector(getPreorder, (state) => state.data);
export const getPaymentOptions = createSelector(self, (state) => state.paymentOptions);
export const getPaymentOptionsData = createSelector(getPaymentOptions, (state) => state.data);
export const getCreate = createSelector(self, (state) => state.create);
export const getStage = createSelector(self, (state) => state.stage);
export const getTravelRuleForm = createSelector(self, (state) => state.travelRuleForm);
